export const defaultLatLong = { lat: 50.9446145, lng: 6.945686799999976 };
export const MIN_PASSWORD_LENGTH = 12;
